import * as Yup from "yup";

export const proofOfOwnershipValidation = Yup.string()
  .test("isProofOfOwnershipDescriptionRequired", "", function () {
    const [{ value: current = null } = {}] = this.from || [];
    const isProofOfOwnershipDescriptionRequired = current?.documents?.some(
      ({ documentTypeId }) => documentTypeId === 0
    );

    if (
      isProofOfOwnershipDescriptionRequired &&
      !current?.proofOfOwnershipDescription
    ) {
      return this.createError({
        message: "Description for document type is required",
      });
    }
    return true;
  })
  .test(
    "isUniqueProofOfOwnershipDescription",
    "Enter unique description",
    function () {
      const [
        {
          value: {
            proofOfOwnershipDescription,
            extraValues: { proofOfOwnershipTypes },
          } = {},
        } = {},
      ] = this.from || [];

      return !proofOfOwnershipTypes.includes(
        proofOfOwnershipDescription?.trim()?.toLowerCase()
      );
    }
  );
